import { defineAsyncComponent } from 'vue'
export default {
  default: defineAsyncComponent(() => import("/tmp/build_b6885e0f/src/layouts/default.vue").then(m => m.default || m))
}